import { render } from "./socialMediaLink.vue?vue&type=template&id=011889a2"
import script from "./socialMediaLink.vue?vue&type=script&lang=js"
export * from "./socialMediaLink.vue?vue&type=script&lang=js"

import "./socialMediaLink.vue?vue&type=style&index=0&id=011889a2&style=scss&lang=css"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-social-post/standard/socialMediaLink.vue'],['render',render],['__file',"socialMediaLink.vue"]])

export default __exports__